import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserAddressDto } from '../models/user-address.dto';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AddressUserService {
  constructor(private readonly api: ApiService) {}

  public async findByUser(id: number): Promise<UserAddressDto[]> {
    const uri: string = environment.api.userAddress + '/' + id;
    return this.api.get<UserAddressDto[]>(uri);
  }

  public async saveAddresses(addresses: UserAddressDto[]): Promise<void> {
    await this.api.post(environment.api.userAddress, addresses);
  }
}
